
/*----------------------------------------------------

  popover.js

----------------------------------------------------*/


// add/remove popover attribute
function updatePopovers(){

	document.querySelectorAll('[data-popoverremove]').forEach(element => {

		const should_remove = element._popover_media_query.matches;

		if(should_remove){

			if(
				typeof element.hidePopover === 'function' &&
				element.matches(':popover-open')
			){
				element.hidePopover();
			}

			element.removeAttribute('popover');

		}else{

			if(!element.hasAttribute('popover')){
				element.setAttribute('popover', 'auto');
			}

		}

	});

}

function initPopovers(){

	document.querySelectorAll('[data-popoverremove]').forEach(element => {

		const condition = element.dataset.popoverremove.trim();

		const match = condition.match(/^(<=|>=|<|>|=)\s*(\d+)$/);

		if(!match){
			return;
		}

		const operator = match[1];
		const breakpoint = parseInt(match[2], 10);

		let media_query = '';

		switch(operator){

			case '<':
				media_query = `(max-width: ${breakpoint - 1}px)`;
				break;

			case '<=':
				media_query = `(max-width: ${breakpoint}px)`;
				break;

			case '>':
				media_query = `(min-width: ${breakpoint + 1}px)`;
				break;

			case '>=':
				media_query = `(min-width: ${breakpoint}px)`;
				break;

			case '=':
				// equality doesn't map cleanly to media queries
				media_query = `(width: ${breakpoint}px)`;
				break;

		}

		element._popover_media_query = window.matchMedia(media_query);

		element._popover_media_query.addEventListener('change', updatePopovers);

	});

	updatePopovers();

}

initPopovers();